import useTranslations from "@/shared/lang/useTranslations";
import { cn } from "@/shared/lib/utils";

import { CARD_STATS_RANGES, type CardStatsRange } from "../types/card-stats.types";

interface PeriodFilterProps {
  value: CardStatsRange;
  onChange: (range: CardStatsRange) => void;
  disabled?: boolean;
}

export function PeriodFilter({ value, onChange, disabled = false }: PeriodFilterProps) {
  const { t } = useTranslations("cards");

  const labels: Record<CardStatsRange, string> = {
    "7d": t("card_stats_range_7d"),
    "30d": t("card_stats_range_30d"),
    "90d": t("card_stats_range_90d"),
    mtd: t("card_stats_range_mtd"),
    ytd: t("card_stats_range_ytd"),
  };

  return (
    <div
      role="tablist"
      aria-label={t("card_stats_range_aria")}
      className="inline-flex items-center gap-1 rounded-md bg-muted p-1"
    >
      {CARD_STATS_RANGES.map((range) => {
        const active = range === value;
        return (
          <button
            key={range}
            type="button"
            role="tab"
            aria-selected={active}
            disabled={disabled}
            onClick={() => onChange(range)}
            className={cn(
              "rounded-sm px-3 py-1.5 text-xs font-medium transition-all",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
              active ? "bg-card text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground",
              disabled && "cursor-not-allowed opacity-60",
            )}
          >
            {labels[range]}
          </button>
        );
      })}
    </div>
  );
}
